import { isBrowser } from "@/utils/env";
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
    }
    Object.defineProperty(MemoryStorage.prototype, "getItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key) {
            return this.store[key] || null;
        }
    });
    Object.defineProperty(MemoryStorage.prototype, "setItem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key, value) {
            this.store[key] = value;
        }
    });
    return MemoryStorage;
}());
var getStorage = function () {
    if (isBrowser) {
        try {
            return window.localStorage;
        }
        catch (e) {
            return new MemoryStorage();
        }
    }
    return new MemoryStorage();
};
export var storage = getStorage();
